<script setup lang="ts">
/**
 * Public marketing footer (DESIGN.md footer-section): 1px top hairline, a single
 * row of small links, copyright at the right edge. Wraps on narrow screens.
 */
const year = new Date().getFullYear();

const links = [
  { href: '/docs', label: 'Docs', external: false },
  { href: '/models', label: 'Models', external: false },
  { href: 'https://github.com/gonka-ai', label: 'GitHub', external: true },
  { href: 'https://t.me/gonka_ai', label: 'Telegram', external: true },
  { href: 'https://gonka.ai', label: 'Gonka', external: true },
];
</script>

<template>
  <footer class="border-t border-hairline bg-canvas">
    <div
      class="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-body"
    >
      <nav class="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        <a
          v-for="l in links"
          :key="l.href"
          :href="l.href"
          :target="l.external ? '_blank' : undefined"
          :rel="l.external ? 'noopener noreferrer' : undefined"
          class="hover:text-ink transition"
          >{{ l.label }}</a
        >
      </nav>
      <span class="text-mute">© {{ year }} Open Gonka</span>
    </div>
  </footer>
</template>
